import { Box } from "@mui/material";
import React from "react";

const SectionDivider = ({
  my = 2,
  color = "#e2e8f0",
  height = "1px",
  mx,
  sx,
}) => {
  return (
    <Box
      sx={{
        height,
        backgroundColor: color,
        my,
        mx,
        ...sx,
      }}
    />
  );
};

export default SectionDivider;
